import * as React from 'react';

import cn from 'classnames';

import { noop } from '@utils';

import { Icon } from '@common/components/Icon';
import { Spinner } from '@common/components/ui';

import { IconClose, IconFile, IconError } from '@icons';

import { IFileProps } from './types';

import * as s from './File.scss';

export class File extends React.Component<IFileProps> {

	static defaultProps: Partial<IFileProps> = {
		onUploadError: noop,
		onUploadCancel: noop,
	};

	componentDidUpdate(prevProps: Readonly<IFileProps>, prevState: Readonly<IFileProps>) {
		const {
			file: {
				meta: {
					isFetched,
					error,
				},
			},
			onUploadError,
			onUploadSuccess,
		} = this.props;
		const {
			file: {
				meta: {
					isFetched: prevIsFetched,
					error: prevError,
				},
			},
		} = prevProps;

		if (!prevIsFetched && isFetched) {
			onUploadSuccess();
		}

		if (!prevError && error) {
			onUploadError(new Error(error.message));
		}
	}

	onRemove = () => {
		const {
			file: {
				meta: {
					isFetching,
				},
			},
			file,
			onRemove,
			onUploadCancel,
		} = this.props;

		if (isFetching) {
			onUploadCancel();
		}

		onRemove(file);
	};

	render() {
		const {
			file: {
				data: {
					title,
				},
				meta: {
					isFetching,
					isFetched,
					error,
				},
			},
			classNames: {
				block: blockClassName,
			} = {},
		} = this.props;

		const isVisible = {
			spinner: isFetching,
			fileIcon: isFetched,
			errorIcon: !!error || !(isFetching || isFetched),
		};

		return (
			<div className={cn(s.block, blockClassName)}>
				{isVisible.spinner &&
					<Spinner
						className={s.spinner}
						size={24}
						color="#d5d5d5"
					/>
				}

				{isVisible.fileIcon &&
					<Icon
						glyph={IconFile}
						className={s.fileIcon}
					/>
				}

				{isVisible.errorIcon &&
					<Icon
						glyph={IconError}
						className={s.errorIcon}
					/>
				}

				<div className={s.title}>
					{title}
				</div>

				<Icon
					glyph={IconClose}
					className={s.removeIcon}
					onClick={this.onRemove}
				/>
			</div>
		);
	}

}
